/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScorePewsCreateAliases {
  AUTOCOMPLETE_CARDIOVASCULAR = 'autocomplete-cardiovascular',
  AUTOCOMPLETE_NEUROLOGICAL_STATUS = 'autocomplete-neurological-status',
  AUTOCOMPLETE_RESPIRATORY = 'autocomplete-respiratory',
  CHECKBOX_NEBULIZATION = 'checkbox-nebulization',
  CHECKBOX_VOMIT = 'checkbox-vomit',
  FETCH_CARDIOVASCULAR = 'fetch-cardiovascular',
  FETCH_NEUROLOGICAL_STATUS = 'fetch-neurological-status',
  FETCH_PROFESSIONAL = 'fetch-professional',
  FETCH_RESPIRATORY = 'fetch-respiratory',
  FIELD_CARDIOVASCULAR = 'field-cardiovascular',
  FIELD_NEBULIZATION = 'field-nebulization',
  FIELD_NEUROLOGICAL_STATUS = 'field-neurological-status',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_RESPIRATORY = 'field-respiratory',
  FIELD_SETUP_DATE = 'field-setup-date',
  FIELD_VOMIT = 'field-vomit',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_SCORE_PEWS_ADD = 'form-score-pews-add',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_PROFESSIONAL = 'input-professional',
  INPUT_SETUP_DATE = 'input-setup-date',
  LOCATOR_FIELD_PROFESSIONAL = 'locator-field-professional',
  LOCATOR_PROFESSIONAL = 'locator-professional',
  MAPPER_CARDIOVASCULAR = 'mapper-cardiovascular',
  MAPPER_NEUROLOGICAL_STATUS = 'mapper-neurological-status',
  MAPPER_RESPIRATORY = 'mapper-respiratory',
  PANEL_BODY = 'panel-body',
  PANEL_FORM = 'panel-form',
  PANEL_HEADER = 'panel-header',
  SCORE_PEWS_ADD_LAYOUT = 'score-pews-add-layout',
  TEXT_CARDIOVASCULAR = 'text-cardiovascular',
  TEXT_NEUROLOGICAL_STATUS = 'text-neurological-status',
  TEXT_RESPIRATORY = 'text-respiratory',
}
export { ScorePewsCreateAliases };
